import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import '../../../assets/css/modal.css'
import './TCModalTournament.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import tcImage from './tc.png'

const TCModalTournament = ({ showTCModalTournament, setShowTCModalTournament }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);
  
  function hideModalOperation() {
    setShowTCModalTournament(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("termsConditions", msisdn);
    analyticEvent('termsConditions', 'termsConditions-view')
  }, [])

  return (
    <>
      <Modal show={showTCModalTournament} centered dialogClassName="modal-dialog" contentClassName="modalContentTcModalTournament" onHide={hideModalOperation}>
        <Modal.Header closeButton >
          <Modal.Title>শর্তাবলী</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "45vh", maxHeight: '525px', overflow: "scroll", display: 'block', overflowX: 'hidden' }}>
        <div className="quizard-rules-container">
      <h4 className="rules-heading">Worldly তে কীভাবে যোগদান করবেন:</h4>
      <p className="rules-paragraph">
        বাংলালিংক নাম্বার থেকে পেমেন্ট এর মাধ্যমে সাপ্তাহিক ৩০ টাকা চার্জে ব্যবহারকারীরা Memory Match, Wordly এবং Spelling Bee তে সাবস্ক্রিপশন করতে পারবেন । একটি বাংলালিংক নাম্বার এর বিপরীতে একাধিক অ্যাকাউন্ট এর সাবস্ক্রিপশন নিতে পারবেন ।
      </p>

      <h5 className="sub-heading">WORDLY খেলার নিয়ম :</h5>
      <ul className="rules-list">
        <li>বাংলা ও ইংরেজি সেগমেন্টে WORDLY তে শব্দ মিল খেলার সুযোগ থাকবে এবং দৈনিক সর্বোচ্চ ২ বার খেলা যাবে ।</li>
        <li>এলোমেলো কিছু অক্ষর থাকবে, এদের সাজিয়ে একটি অর্থপূর্ণ শব্দ পাওয়া যাবে । কোনো অক্ষর তার সঠিক স্থানে থাকলে সবুজ রেখা দ্বারা সেটি অংশগ্রহণকারীর দৃষ্টিগোচর হবে ।</li>
        <li>অংশগ্রহণকারীরা প্রতিটি সঠিক শব্দের জন্য ১ পয়েন্ট অর্জন করবে। প্রতি রাউন্ড এর সময় সীমা ১৮০ সেকেন্ড ।</li>
        <li>প্রতি রাউন্ড এ অংশগ্রহণকারী গণ নির্দিষ্ট সময়ে যে কয়টি সঠিক শব্দ মিল করবে, সেটিই হবে তার ঐ রাউন্ড এর টোটাল স্কোর ।</li>
        <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
      </ul>

      <h5 className="sub-heading">Spelling Bee খেলার নিয়ম :</h5>
      <ul className="rules-list">
        <li>স্পেলিং বি সেগমেন্টে ইংরেজিতে ৭ টি লেটার  দেয়া থাকবে। এখান থেকে শব্দ মিল করার সুযোগ থাকবে এবং দৈনিক সর্বোচ্চ ২ বার খেলা যাবে।</li>
        <li>অংশগ্রহণকারীরা প্রতিটি সঠিক শব্দের জন্য ১ পয়েন্ট অর্জন করবে। প্রতি রাউন্ড এর সময় সীমা ১৮০ সেকেন্ড।</li>
        <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
      </ul>

      <h5 className="sub-heading">Memory Match খেলার নিয়ম:</h5>
      <ul className="rules-list">
        <li><strong>কার্ড সাজানো:</strong> সমস্ত কার্ড (সাধারণত জোড়া সংখ্যক) খেলার মাঠে গ্রিড আকারে মুখ নিচে সাজানো হয়। প্রতিটি কার্ডের সাথে একটি নির্দিষ্ট চিত্র বা চিহ্ন মেলে, যার জোড়া খেলায় বিদ্যমান।</li>
        <li><strong>খেলোয়াড়ের পালা:</strong> প্রতিবার খেলোয়াড় দুটি কার্ড উল্টবেন। যদি উল্টানো দুই কার্ডের চিত্র বা চিহ্ন একই হয়, তাহলে সেগুলি মিল হয় এবং স্থায়ীভাবে উন্মুক্ত থাকবে। যদি মিল না হয়, নির্দিষ্ট কিছু সময় (উদাঃ ২-৩ সেকেন্ড) পর কার্ডগুলি আবার মুখ নিচে ফিরিয়ে দেওয়া হবে।</li>
        <li><strong>মনে রাখা কৌশল:</strong> খেলার সময় পূর্বে উল্টানো কার্ডগুলির অবস্থান মনে রাখা অত্যন্ত জরুরি, যাতে পরবর্তীতে দ্রুত মিল খুঁজে পাওয়া যায়।</li>
        <li><strong>সময় গণনা:</strong> খেলার শুরু থেকে শেষ পর্যন্ত সময় মাপা হবে। যিনি সব কার্ডের জোড়া মিলিয়ে খেলা সম্পূর্ণ করবেন, তার মোট সময় ধরে নেওয়া হবে। বিজয়ী হবে সেই খেলোয়াড় যিনি সর্বনিম্ন সময়ে খেলা শেষ করেন।</li>
      </ul>

      <h5 className="sub-heading">প্রাইজ</h5>
      <ul className="rewards-list">
        <li>
          <strong>Memory Match টুর্নামেন্ট পুরস্কার:</strong><br/>
          ১ম পুরস্কার: Samsung Galaxy Tab A9+ Wi-Fi 4GB RAM 64GB Storage 11-inch Tablet<br/>
          ২য় পুরস্কার: Smartphone Samsung Galaxy F13 (6/128 GB)<br/>
          ৩য় পুরস্কার: গিফট কার্ড / ৫০০০ টাকা<br/>
          টুর্নামেন্ট শেষে অংশগ্রহণকারীদের টোটাল স্কোর ও সময় গণনা করা হবে এবং সেই অনুযায়ী প্রাইজ দেয়া হবে
        </li>
        <li>
          <strong>মেমোরি ম্যাচ গেমে প্রতিদিনের শীর্ষ ৩০ জন বিজয়ী পাবেন বিকাশ ক্যাশ ইন পুরস্কার:</strong><br/>
          বিগিনার লেভেল-এর শীর্ষ ১০ জন পাবেন ১০ টাকা করে।<br/>
          ইন্টারমিডিয়েট লেভেল-এর শীর্ষ ১০ জন পাবেন ১৫ টাকা করে।<br/>
          অ্যাডভান্সড লেভেল-এর শীর্ষ ১০ জন পাবেন ২০ টাকা করে বিকাশ ক্যাশ ইন পুরস্কার।<br/>
          ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
        </li>
        <li>
          <strong>Wordly পুরস্কার:</strong><br/>
          দৈনিক পুরস্কার: প্রতিদিনের অংশগ্রহণকারীদের মধ্যে সেরা ৩০ জন সঠিক উত্তর প্রদানকারী কে ১০ টাকা বিকাশ ক্যাশ ইন করা হবে |<br/>
          সাপ্তাহিক পুরস্কার: প্রতি সপ্তাহের ১০ জন  সর্বোচ্চ স্কোর ধারী অংশগ্রহণকারী কে ৩০০ টাকা পর্যন্ত বিকাশ ক্যাশ ইন করা হবে |<br/>
          ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
        </li>
        <li>
          <strong>Spelling Bee পুরস্কার:</strong><br/>
          দৈনিক পুরস্কার: প্রতিদিনের অংশগ্রহণকারীদের মধ্যে সেরা ২০ জন সঠিক উত্তর প্রদানকারী কে ১০ টাকা বিকাশ ক্যাশ ইন করা হবে |<br/>
          সাপ্তাহিক পুরস্কার: প্রতি সপ্তাহের ১০  জন  সর্বোচ্চ স্কোর ধারী অংশগ্রহণকারী কে ২৫০ টাকা পর্যন্ত বিকাশ ক্যাশ ইন করা হবে |<br/>
          ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
        </li>
        <li>
          <strong>১০ টাকা ক্যাশ ইন প্রাইজঃ</strong><br/>
          আপনার রেফার কোড ব্যাবহার করে কেউ যদি সাবস্ক্রিপশন করে, তাহলে প্রতি সফল সাবস্ক্রিপশনে আপনি পেয়ে যাবেন ১০ টাকা ক্যাশ ইন।<br/>
          ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
        </li>
      </ul>
    </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default TCModalTournament